// extracted by mini-css-extract-plugin
module.exports = {"Root":"InfoSettingsButton_Root__2aT1Z"};